import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { ContentSettings } from 'assets/js/pages/account-settings/account-about/ContentSettings';
import { GeneralDonationsSettings } from 'assets/js/pages/account-settings/account-about/GeneralDonationsSettings';
import { GivingHubSettings } from 'assets/js/pages/account-settings/account-about/GivingHubSettings';
import { SlugSettings } from 'assets/js/pages/account-settings/account-about/SlugSettings';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LandingPageSettings = () => {
    const { hasGivingHub } = useCurrentAccount();

    return (
        <Box className="flex flex-col gap-8 p-8">
            <SlugSettings />
            <Separator />

            {!hasGivingHub ? (
                <>
                    <GivingHubSettings />
                    <Separator />
                </>
            ) : null}

            <ContentSettings />
            <Separator />

            <GeneralDonationsSettings />
        </Box>
    );
};

export { LandingPageSettings };
